import { useToast } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { RanaEditable, RanaHeading, RanaHeadingEditablePreview } from "@nens/ranalib";

import { useEditPublication } from "../_internal";
import { getIsEditable, getName } from "../store/selectors";
import { usePublicationStore } from "../store/store";

export function PublicationNameEditable() {
  const publicationName = usePublicationStore(getName);
  const publicationId = usePublicationStore((state) => state.id);
  const intl = useIntl();
  const toast = useToast();
  const isEditable = usePublicationStore(getIsEditable);
  const { mutateAsync } = useEditPublication();
  const handleSubmit = async (value: string) => {
    await mutateAsync({ publicationId, publicationUpdate: { name: value } });
    toast({
      description: intl.formatMessage({
        id: "publication.edit_name_successfully",
        defaultMessage: "Publication name has been updated successfully for all versions",
      }),
      status: "success",
    });
  };

  if (!isEditable) {
    return (
      <RanaHeading type="h3" py={2}>
        {publicationName}
      </RanaHeading>
    );
  }

  return (
    <RanaEditable defaultValue={publicationName} onSubmit={handleSubmit}>
      <RanaHeadingEditablePreview type="h3" py={2} cursor="pointer" />
      <RanaEditable.Input />
    </RanaEditable>
  );
}
